// extracted by mini-css-extract-plugin
module.exports = {"footer":"TheFooter-Jtails_footer_3UEDI","menuList":"TheFooter-Jtails_menuList_3bcQH","socialList":"TheFooter-Jtails_socialList_2QxfJ"};